export default "__VITE_ASSET__CH7_Yu0D__"